import type { TargetEnum } from 'src/graphql/queries/menu'
import { useLocation } from '@reach/router'
import { Link } from 'gatsby'

const isInternalLink = (url: string, baseOrigin: string): boolean => {
  if (url.startsWith('/')) {
    return true
  }

  try {
    const parsedUrl = new URL(url, baseOrigin)

    return parsedUrl.origin === baseOrigin
  } catch {
    return false
  }
}

const FlexibleLink = ({
  label,
  linkUrl,
  classNames,
  children,
  onClick,
  target,
  title,
  testId,
}: {
  linkUrl: string
  label?: string
  classNames?: string
  children?: React.ReactNode
  onClick?: () => void
  target?: TargetEnum
  title?: string
  testId?: string
}) => {
  const { origin } = useLocation()

  return isInternalLink(linkUrl, origin) ? (
    <Link
      to={linkUrl}
      className={classNames}
      onClick={() => onClick?.()}
      {...(title ? { title } : {})}
      {...(testId ? { 'data-testid': testId } : {})}
    >
      {label}
      {children}
    </Link>
  ) : (
    <a
      href={linkUrl}
      className={classNames}
      target={target ?? '_blank'}
      rel="noopener noreferrer"
      onClick={() => onClick?.()}
      {...(title ? { title } : {})}
      {...(testId ? { 'data-testid': testId } : {})}
    >
      {label}
      {children}
    </a>
  )
}

export default FlexibleLink
